import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useSignal, useId, useContextProvider, Slot } from "@builder.io/qwik";
import { popoverContextId } from "./popover-context.qwik.mjs";
const HPopoverRoot = component$((props) => {
  const { id, "bind:anchor": givenAnchorRef, "bind:panel": givenPanelRef, floating = true, manual, hover = false, gutter, flip = true, shift, hide, arrow, ancestorScroll = true, ancestorResize = true, elementResize = true, animationFrame = false, transform, ...rest } = props;
  const anchorRef = givenAnchorRef;
  const rootRef = useSignal();
  const defaultPanelRef = useSignal();
  const panelRef = givenPanelRef ?? defaultPanelRef;
  const triggerRef = useSignal();
  const arrowRef = useSignal();
  const isOpenSig = useSignal(false);
  const localId = useId();
  const compId = id ?? localId;
  const rootId = `${compId}-root`;
  const context = {
    anchorRef,
    compId,
    floating,
    hover,
    panelRef,
    triggerRef,
    arrowRef,
    isOpenSig,
    localId,
    manual,
    arrow,
    gutter,
    flip,
    shift,
    hide,
    ancestorScroll,
    ancestorResize,
    elementResize,
    animationFrame,
    transform
  };
  useContextProvider(popoverContextId, context);
  return /* @__PURE__ */ jsx("div", {
    ref: rootRef,
    id: rootId,
    ...rest,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HPopoverRoot
};
